module.exports = __webpack_public_path__ + "img/gallery-image-18.eebe56f7.jpg";